var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6527 14.1619C12.5784 14.0876 12.4507 14.0781 12.3593 14.1448C12.3593 14.1448 12.3669 14.1391 12.2907 14.1924C11.0216 15.0861 9.47432 15.6101 7.80507 15.6101C3.49477 15.6101 0 12.1154 0 7.80507C0 3.49477 3.49477 0 7.80507 0C12.1154 0 15.6101 3.49477 15.6101 7.80507C15.6101 9.46666 15.0918 11.0064 14.2058 12.2716C14.1486 12.3555 14.1429 12.3612 14.1429 12.3612C14.0781 12.4469 14.0895 12.5803 14.1619 12.6527L14.6288 13.1196C14.7031 13.1939 14.8536 13.2339 14.9508 13.211C14.9508 13.211 14.9394 13.211 15.0289 13.1977C15.6978 13.0929 16.4047 13.2987 16.9192 13.8132L19.3583 16.2523C20.2139 17.1097 20.2139 18.5008 19.3583 19.3583C18.5008 20.2139 17.1098 20.2139 16.2523 19.3583L13.8132 16.9192C13.3025 16.4066 13.0967 15.7035 13.1958 15.0384C13.2092 14.947 13.2111 14.9565 13.2111 14.9565C13.2358 14.8498 13.192 14.7011 13.1196 14.6287L12.6527 14.1619ZM7.80506 12.6833C10.4995 12.6833 12.6832 10.4995 12.6832 7.80511C12.6832 5.11071 10.4995 2.92694 7.80506 2.92694C5.11065 2.92694 2.92689 5.11071 2.92689 7.80511C2.92689 10.4995 5.11065 12.6833 7.80506 12.6833Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.ef4384a260e5053c7e3e00bba001a0d5.svg";
export { ForwardRef as ReactComponent };